import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { AppService } from 'app/services/app/app.service';
import { LegalPage, LegalPageContent } from './legal-page.service';

const TITLE_KEYS: Record<LegalPage, string> = {
  'legal-notice': 'legal.legalNotice',
  'privacy-policy': 'legal.privacyPolicy',
  'terms-service': 'legal.termsService',
  'cookie-policy': 'legal.cookiePolicy',
};

@Component({
  selector: 'app-legal-page',
  templateUrl: './legal-page.component.html',
  styleUrls: ['./legal-page.component.scss'],
  standalone: false,
})
export class LegalPageComponent implements OnInit {
  titleKey = '';
  content: string | null = null;

  constructor(private route: ActivatedRoute, private title: Title, private appService: AppService) {}

  ngOnInit(): void {
    this.route.data.subscribe(data => {
      this.titleKey = TITLE_KEYS[data['page'] as LegalPage];
      this.content = (data['legalContent'] as LegalPageContent | null)?.content ?? null;
      this.title.setTitle(this.appService.getTraduccion(this.titleKey));
    });
  }
}
